enum AvailabilityError {
  IsSold = 'IsSold',
  None = 'None',
  NotAvailableInCA = 'NotAvailableInCA',
  OnSitePrivate = 'OnSitePrivate',
  OutOfMarket = 'OutOfMarket',
  PurchasePending = 'PurchasePending',
  StopSaleRecall = 'StopSaleRecall',
  Unavailable = 'Unavailable',
  UnavailableReserved = 'UnavailableReserved'
}

export default AvailabilityError;
